import React from "react";
import { useLandingPageMeta } from "../hooks/useLandingPageMeta";
import LandingHeader from "../components/landing/LandingHeader";
import HeroSection from "../components/landing/HeroSection";
import ProblemSection from "../components/landing/ProblemSection";
import SolutionSection from "../components/landing/SolutionSection";
import GuestFlowSection from "../components/landing/GuestFlowSection";
import CoupleDashboardSection from "../components/landing/CoupleDashboardSection";
import InstallmentHighlightSection from "../components/landing/InstallmentHighlightSection";
import WeddingWalletSection from "../components/landing/WeddingWalletSection";
import AppDownloadSection from "../components/landing/AppDownloadSection";
import TrustSecuritySection from "../components/landing/TrustSecuritySection";
import FAQSection from "../components/landing/FAQSection";
import FinalCTASection from "../components/landing/FinalCTASection";
import LandingFooter from "../components/landing/LandingFooter";
import ScrollToTop from "../components/ScrollToTop";

const Home: React.FunctionComponent = () => {
    useLandingPageMeta();

    return (
        <div className="landing-page">
            <LandingHeader />
            <main>
                <HeroSection />
                <ProblemSection />
                <SolutionSection />
                <GuestFlowSection />
                <CoupleDashboardSection />
                <InstallmentHighlightSection />
                <WeddingWalletSection />
                <AppDownloadSection />
                <TrustSecuritySection />
                <FAQSection />
                <FinalCTASection />
            </main>
            <LandingFooter />
            <ScrollToTop />
        </div>
    );
};

export default Home;
